import { Center, Spinner } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { useSearchBox } from 'react-instantsearch';
import { bcApi } from '../../../../helpers/bigcommerce';
import { useGlobalStore } from '../../../../stores/global';
import Icon from '../../../atoms/Icon/Icon';

const BigcommerceHits = () => {
  const { setShowSearch } = useGlobalStore(state => state);
  const { query } = useSearchBox();

  const { data: categories, isLoading } = useQuery(
    ['search_categories', query],
    async () =>
      bcApi(
        `catalog/categories?is_visible=true&name:like=${query}&limit=2`,
        'GET'
      ),
    {
      enabled: !!query
    }
  );

  return (
    <section className="grid-bc">
      {!!query && isLoading && (
        <Center>
          <Spinner size={'xs'} color="teal" />
        </Center>
      )}
      {categories && (
        <>
          <p className="title mt-4">categories</p>
          <ol className="suggestions">
            {categories?.response?.data?.length > 0 ? categories?.response?.data?.map(category => (
              <li className="default-hover" key={category.id}>
                <div>
                <a href={category.custom_url.url} onClick={(e)=>{
                  e.preventDefault();
                  setShowSearch(false);
                  window.location.href = category.custom_url.url;
                }}>
                    <Icon symbol={'search'} />
                    <p>{category.name}</p>
                </a>
                </div>
              </li>
            )): <p className="no-results">No results</p>}
          </ol>
        </>
      )}
    </section>
  );
};

export default BigcommerceHits;
